import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generatePath } from 'react-router-dom';
import {
  API_ASSET_MAPPING_ADX,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_MAPPING_ADX,
} from '../constants';

const api = ({ solutionId, tableName }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_ASSET_MAPPING_ADX, { solutionId, tableName }),
  });

const assetMappingAdx = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_MAPPING_ADX,
  responseMapping: ResponseMapping.Default,
});

export default assetMappingAdx;
